export const CITIZENSHIP_TYPES = {
  ALL: 'All',
  DOMESTIC: 'Domestic',
  INTERNATIONAL: 'International',
};
